import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useMiniCashierCommunicationHandler } from "../components/MiniCashier/index.js";
import {
  CashierTab,
  MyAccountTab,
  PaymentAppType
} from "../constants/index.js";
import { AppFeatures } from "../constants/featureFlags.js";
import { UserContextSelectors } from "../redux/selectors/index.js";
import { useAccountCommunicationHandlers } from "./useAccountCommunicationHandlers.js";
import { useFeature } from "./useFeature.js";

export const useUserCommunication = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);

  const { openMyAccount } = useAccountCommunicationHandlers();
  const { openCashier } = useMiniCashierCommunicationHandler();

  const isVerificationIVEnabled = useFeature(AppFeatures.VERIFICATION_IV);

  const openCashierUploadDocuments = useCallback(
    (area, element, source, actionId) => {
      openCashier({
        Area: area,
        Element: element,
        Source: source,
        ActionId: actionId,
        TabId: isMobile
          ? parseInt(CashierTab.MobileVerifyID)
          : parseInt(CashierTab.VerifyID),
        AppType: PaymentAppType.FullCashier
      });
    },
    [isMobile, openCashier]
  );

  const openMyAccountUploadDocuments = useCallback(() => {
    openMyAccount({
      tabId: parseInt(MyAccountTab.IdentityVerification),
      hideHeader: true,
      hideMenu: true,
      showInAppCloseButton: true
    });
  }, [openMyAccount]);

  const openUploadDocuments = useCallback(
    (area, element, source, actionId) => {
      if (isVerificationIVEnabled) openMyAccountUploadDocuments();
      else openCashierUploadDocuments(area, element, source, actionId);
    },
    [
      isVerificationIVEnabled,
      openMyAccountUploadDocuments,
      openCashierUploadDocuments
    ]
  );

  return {
    openUploadDocuments,
    openMyAccountUploadDocuments,
    openCashierUploadDocuments
  };
};
